module.exports = __webpack_public_path__ + "static/img/2_6_1.9f67f032.jpg";